export default __webpack_public_path__ + "static/media/avatar-4.93166a0c.jpg";